import { render, staticRenderFns } from "./index.vue?vue&type=template&id=511630c1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511630c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511630c1')) {
      api.createRecord('511630c1', component.options)
    } else {
      api.reload('511630c1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=511630c1&scoped=true", function () {
      api.rerender('511630c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-manage/index.vue"
export default component.exports